// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__bJ72n","tall":"Modal_tall__qglBm","overlay":"Modal_overlay__dGNwL"};